<div>
  <ul *ngIf="metadata">
    <li *ngFor="let cvDetails of metadata.cv_versions | keyvalue">
      {{cvDetails.key}}: {{cvDetails.value}}
    </li>
  </ul>
</div>